@file:kotlin.js.JsExport
package com.narbase.letsgo.web.routing.domain.admin.pointofinterest

import com.narbase.letsgo.router.EndPoint

object ReindexPointsOfInterestSearchEndpoint :
    EndPoint<ReindexPointsOfInterestSearchEndpoint.Request, ReindexPointsOfInterestSearchEndpoint.Response>() {
    class Request()

    class Response(
        val isActive: Boolean,
        val indexedPointsCount: Int,
    )
}
